var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftcards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.402,
    height: 26.406,
    viewBox: "0 0 32.402 26.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1b1c1d;}.b{fill:#d3d3d3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 19,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0.65, 5.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,22H.986A.986.986,0,0,1,0,21.012V.986a.986.986,0,0,1,1.971,0V20.026H14.019V1.971l-3.865.409a.986.986,0,1,1,0-1.971L15,0a.986.986,0,0,1,.986.986V21.012A.986.986,0,0,1,15,22Z",
    transform: "translate(21.723 21.394) rotate(163)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 19,
    transform: "translate(17.54 2.024) rotate(22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,22.02H.986A.986.986,0,0,1,0,21.034V1.008a.986.986,0,0,1,1.971,0V20.048H14.018V1.993L4.006,1.971A.986.986,0,1,1,4.006,0L15,.022a.986.986,0,0,1,.986.986V21.034A.986.986,0,0,1,15,22.02Z",
    transform: "translate(17.577 0) rotate(22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M251.637,189.581a2.818,2.818,0,0,0-2.232-.012,2.673,2.673,0,0,0-1.466-1.433,2.58,2.58,0,0,0-2.062.086h0a2.872,2.872,0,0,0-1.34,1.916c-.711,2.61,2.032,5.3,2.347,5.6a.371.371,0,0,0,.255.1h.008c.741-.016,4.494-.215,5.6-2.608a2.92,2.92,0,0,0,.22-2.255A2.59,2.59,0,0,0,251.637,189.581Zm.44,3.339c-.868,1.874-3.986,2.136-4.791,2.172-.553-.551-2.581-2.745-2.032-4.759a2.178,2.178,0,0,1,.967-1.454,1.857,1.857,0,0,1,1.451-.051,2.045,2.045,0,0,1,1.164,1.343.374.374,0,0,0,.547.228,2.228,2.228,0,0,1,1.942-.145,1.84,1.84,0,0,1,.95.982A2.178,2.178,0,0,1,252.076,192.92Z",
    transform: "translate(-227.459 -178.113)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftcards);
export default __webpack_public_path__ + "static/media/Giftcards.d0c21a3e0bb656c965db637d970d73b6.svg";
export { ForwardRef as ReactComponent };